// extracted by css-extract-rspack-plugin
export default {"cls1":"MentionsCardHeader-cls1_wXn","cls2":"MentionsCardHeader-cls2_wuQ MentionsCardHeader-cls1_wXn"};